<div
  class="tag-list"
  [class.tag-list-sm]="size === 'small'"
  [class.tag-list-md]="size === 'medium'"
  [class.tag-list-lg]="size === 'large'"
  [class.tag-list-primary]="style === 'primary'"
  [class.tag-list-success]="style === 'success'"
  [class.tag-list-warning]="style === 'warning'"
  [class.no-wrap]="noWrap"
  >
  @for (tag of visibleTags; track tag) {
    <div class="tag" [attr.data-color]="tag.color">
      <i class="tag-icon"></i>
      <div class="tag-number">
        @for (digit of tag.text.split(''); track digit) {
          <span>{{ digit }}</span>
        }
      </div>
    </div>
  }
  <!-- HACK: Create extra flex gap to add end padding when scrolling horizontally -->
  @if (noWrap) {
    <div style="width: 0">&nbsp;</div>
  }
</div>

@if (isCollapsed && numberOfHiddenTags > 0) {
  <div class="expand-tags">
    <a class="expand-tags-cta" (click)="isCollapsed = false"
      ><span
      >{{ 'SHOW_X_MORE_TAGS_PRE' | lhTranslate }} {{ numberOfHiddenTags }}
      {{ 'SHOW_X_MORE_TAGS_POST' | lhTranslate }}</span
      ><i class="bi bi-caret-down-fill"></i>
    </a>
  </div>
}
